module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0